import { render, staticRenderFns } from "./NodeOnboardingPaletteButton.vue?vue&type=template&id=7d7c02c3&"
import script from "./NodeOnboardingPaletteButton.vue?vue&type=script&lang=ts&"
export * from "./NodeOnboardingPaletteButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports